import './MatrixCategoryPage.css';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PdfTable from './PDFTable';
import Header from './Header';
import { categories, slugify } from '../../services/categories';
import { AuthContext } from '../../services/AuthContext';
import { collection, query, onSnapshot } from 'firebase/firestore';

function MatrixCategoryPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, firebaseUid, db } = useContext(AuthContext);
  const [authorizedUids, setAuthorizedUids] = useState([]);
  const [readUids, setReadUids] = useState([]);
  const [loadingAuth, setLoadingAuth] = useState(true);
  const [showDenied, setShowDenied] = useState(false);

  const pathSegments = location.pathname.split('/');
  const lastSegment = pathSegments[pathSegments.length - 1];
  const categoryFullName = categories.find(cat => slugify(cat) === lastSegment) || 'Categoría no encontrada';

  useEffect(() => {
    if (!db) return;
    const q = query(collection(db, 'userRoles'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const canEditCNA = [];
      const canReadCNA = [];
      snapshot.forEach((doc) => {
        if (doc.data().canEditCNA === true) canEditCNA.push(doc.id);
        if (doc.data().canReadCNA === true) canReadCNA.push(doc.id);
      });
      setAuthorizedUids(canEditCNA);
      setReadUids(canReadCNA);
      setLoadingAuth(false);
    });
    return unsubscribe;
  }, [db]);

  useEffect(() => {
    if (!loadingAuth && firebaseUid) {
      const uid = firebaseUid;
      if (!authorizedUids.includes(uid) && !readUids.includes(uid) || uid == undefined || uid == null) {
        setShowDenied(true);
        setTimeout(() => {
          setShowDenied(false);
          navigate('/', { replace: true });
        }, 2000);
      }
    }
  }, [loadingAuth, firebaseUid, authorizedUids, readUids, navigate]);

  if (showDenied) {
    return (
      <div className="App">
        <Header />
        <main>
          <div style={{color:'#cf1919',fontWeight:600,margin:'2rem auto',textAlign:'center',fontSize:'1.3rem'}}>Permisos insuficientes para visualizar esta página</div>
        </main>
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <h3>{categoryFullName}</h3>
      <main>
        <PdfTable name={lastSegment} />
      </main>
    </div>
  );
}

export default MatrixCategoryPage;
